import { __read } from "tslib";
import { timeDay, timeMinute, timeMonth, timeWeek, timeHour, timeYear, } from 'd3-time';
import { TIME_UNIT, TIME_INTERVALS } from './constants';
var timeModifier = {
    day: timeDay,
    minute: timeMinute,
    hour: timeHour,
    week: timeWeek,
    month: timeMonth,
    year: timeYear,
};
var createTimeIntervals = function (scale, minimumTickWidth) {
    if (minimumTickWidth === void 0) { minimumTickWidth = 70; }
    var _a = __read(scale.range(), 2), startDimension = _a[0], endDimension = _a[1];
    var axisDimension = endDimension - startDimension;
    var _b = __read(scale.domain(), 2), start = _b[0], end = _b[1];
    var defaultTickInterval = end.getTime() - start.getTime();
    var unit = TIME_INTERVALS[TIME_INTERVALS.length - 1], interval = TIME_UNIT[unit[0]], multiples = unit[1];
    TIME_INTERVALS.some(function (timeIntervalUnit, i) {
        var _a = __read(timeIntervalUnit, 2), intervalUnit = _a[0], intervalMultiples = _a[1];
        unit = timeIntervalUnit;
        interval = TIME_UNIT[intervalUnit];
        multiples = intervalMultiples;
        if (TIME_INTERVALS[i + 1]) {
            var newInterval = interval * multiples[multiples.length - 1] +
                TIME_UNIT[TIME_INTERVALS[i + 1][0]];
            return defaultTickInterval <= newInterval;
        }
    });
    var intervalDividers = multiples.filter(function (value) {
        var ms = value * TIME_UNIT[unit[0]];
        return Math.round(defaultTickInterval / ms);
    });
    if (intervalDividers.length === 0) {
        intervalDividers = [1];
    }
    var modifier = timeModifier[unit[0]];
    var ticksRanges = intervalDividers.map(function (stepRange) {
        return modifier.range(start, end, stepRange);
    });
    var tickRatio = Math.floor(axisDimension / minimumTickWidth);
    var ticks = ticksRanges.reduce(function (prev, curr) {
        return Math.abs(curr.length - tickRatio) < Math.abs(prev.length - tickRatio)
            ? curr
            : prev;
    });
    return {
        ticks: ticks,
        precision: unit[0],
    };
};
export default createTimeIntervals;
